import { gql } from "@grandvisionhq/graphql";
import { getReturnFailuresFragment } from "../../../fragments/operations/fragments/get-return-failures.js";
import { returnFragmentForLogin } from "../../../fragments/operations/fragments/return.js";
const GET_RETURN_FOR_LOGIN = gql`
  query GetReturnForLogin($input: GetReturnInput!) {
    getReturn(input: $input) {
      return {
        ...ReturnFragmentForLogin
      }
      failures {
        ...GetReturnFailuresFragment
      }
    }
  }
  ${returnFragmentForLogin}
  ${getReturnFailuresFragment}
`;
export {
  GET_RETURN_FOR_LOGIN
};
//# sourceMappingURL=get-return-for-login.js.map
